import React, { useEffect, useState } from 'react';
import { getKollaSyncStatus } from '../services/paymentsService.js';
import { parseBackendDate } from '../services/common.js';
import { formatRelative, isSyncStale } from './syncFreshness.js';

const POLL_MS = 60_000;

/**
 * Warning across the top of the Ledger and Schedule tabs when the PMS sync
 * is behind (see ``isSyncStale``). Balances, today's procedures and family
 * totals there come from the synced copy of the PMS, so staff should take
 * amounts from the PMS itself until the sync catches up. Renders nothing
 * while the data is fresh or the practice has no synced PMS.
 */
const StaleSyncBanner = ({ practiceId }) => {
  const [status, setStatus] = useState(null);
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    if (!practiceId) return undefined;
    let cancelled = false;
    const load = async () => {
      try {
        const data = await getKollaSyncStatus(practiceId);
        if (!cancelled && data && data.success) setStatus(data);
      } catch (_) { /* keep the last known status */ }
      if (!cancelled) setNow(new Date());
    };
    load();
    const t = setInterval(load, POLL_MS);
    return () => { cancelled = true; clearInterval(t); };
  }, [practiceId]);

  if (!isSyncStale(status, now)) return null;

  const succeeded = parseBackendDate(status.lastSucceededAt);
  const when = succeeded ? `last synced ${formatRelative(succeeded, now)}` : 'it has never synced';
  return (
    <div
      role="alert"
      style={{
        backgroundColor: '#fdf3e3',
        border: '1px solid #f3d9ae',
        color: '#a8520c',
        padding: '10px 14px',
        borderRadius: 8,
        fontSize: 13,
        lineHeight: 1.45,
        marginBottom: 14,
      }}
    >
      <strong>PMS data is out of date</strong> ({when}). Balances and today&apos;s procedures may be
      missing here. Check amounts in your PMS before charging.
    </div>
  );
};

export default StaleSyncBanner;
